export default __webpack_public_path__ + "static/media/badge-button.055ab009.svg";